import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const RECORDINGS_SIDEBAR_DATA = [
  {
    header: 'MODULE RECORDING',
    tabs: [
      {
        tabName: 'View Pending Requests',
        to: '/recordings/view-pending-requests',
        subject: PERMISSION_SUBJECTS.recordingRequest,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];
export default RECORDINGS_SIDEBAR_DATA;
